import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/sitios`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(sitio) {
    return apiClient.post(`${sitio.id}`, sitio)
  },

  eliminar(idSitio) {
    return apiClient.delete(`${idSitio}`)
  },

  guardar(sitio) {
    return apiClient.post('', sitio)
  },

  sitioJSON(idSitio) {
    return apiClient.get(`${idSitio}.json`)
  },

  sitiosJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/sitios.json`, { params: params })
  },
  relsSitiosJSON(params) {
    return apiClient.get('rels-sitios.json', { params: params })
  },

  actualizarAjustesWhatsapp(ajustes) {
    return apiClient.post('ajustes-whatsapp', ajustes)
  },

  testWhatsapp(datos) {
    return apiClient.post('test-whatsapp', datos)
  },

  generarWebhookToken() {
    return apiClient.post('generar-webhook-token')
  },

  crearPlantillaWhatsapp(datos) {
    return apiClient.post('crear-plantilla-whatsapp', datos)
  },

  actualizarPlantillaWhatsapp(datos) {
    return apiClient.post('actualizar-plantilla-whatsapp', datos)
  },

  consultarPlantillasWhatsapp(params) {
    params = params || {}
    return apiClient.get('plantillas-whatsapp', { params: params })
  },

  eliminarPlantillaWhatsapp(datos) {
    return apiClient.post('eliminar-plantilla-whatsapp', datos)
  },

  obtenerRespuestasRapidasWhatsapp() {
    return apiClient.get('respuestas-rapidas-whatsapp')
  },

  guardarRespuestasRapidasWhatsapp(respuestas) {
    return apiClient.post('respuestas-rapidas-whatsapp', { respuestas: respuestas })
  }
}
